/** True for localhost / loopback hosts (with or without port). */
export function isLocalHost(host?: string | null): boolean {
  if (!host) return false
  const raw = host.trim().toLowerCase()
  if (!raw) return false

  // Bracketed IPv6 with optional port: [::1]:3000
  const bracket = raw.match(/^\[([^\]]+)\](?::\d+)?$/)
  if (bracket?.[1]) {
    return bracket[1] === '::1'
  }

  // Bare IPv6 loopback (no port in Host header usually)
  if (raw === '::1') return true

  // hostname or IPv4 with optional port
  const hostname = raw.includes(':') ? raw.slice(0, raw.lastIndexOf(':')) : raw
  if (!hostname) return false

  return (
    hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '0.0.0.0'
    || hostname.endsWith('.localhost')
  )
}
